import { render, staticRenderFns } from "./ImageUploadDemo.vue?vue&type=template&id=afbb48a2&scoped=true"
import script from "./ImageUploadDemo.vue?vue&type=script&lang=js"
export * from "./ImageUploadDemo.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadDemo.vue?vue&type=style&index=0&id=afbb48a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb48a2",
  null
  
)

export default component.exports